// @flow
import React, { useContext } from 'react';
import { Formik, type FormikHelpers } from 'formik';

import { t } from 'Src/i18n';
import ReactAppContext from 'Context/ReactAppContext';

import {
  FORM_STATUS,
  getFormSchema,
  getInitialFormValues,
  handleSubmit,
  type FormProduct,
  type FormStatus,
  type FormValues,
  type TrackingData,
} from './productQuotationForm.utils';
import { ProductQuotationForm, type ProductQuotationFormProps } from './ProductQuotationForm';

type ProductQuotationFormContainerProps = {
  ...$Exact<ProductQuotationFormProps>,
  product: FormProduct,
  quotation: { error: FormStatus, success: FormStatus },
  trackingData: TrackingData,
};

export function ProductQuotationFormContainer({
  adultsOptions,
  ageIndicationAdults,
  ageIndicationKids,
  availableDatesIndication,
  civilityOptions,
  dateFormat,
  departureCityOptions,
  departureDateOptions,
  departureDateEnd,
  departureDateStart,
  extensionOptions,
  footnotes,
  isEscapade,
  isSummerCamp,
  kidsOptions,
  newsletter,
  newsletterOptins,
  product,
  quotation,
  trackingData,
}: ProductQuotationFormContainerProps) {
  const appContext = useContext(ReactAppContext);

  return (
    <Formik
      initialStatus={{ state: FORM_STATUS.NEW }}
      initialValues={getInitialFormValues({ extensionOptions, isSummerCamp, isEscapade })}
      validateOnMount
      validationSchema={getFormSchema(t, {
        civilityOptions,
        departureCityOptions,
        departureDateOptions,
        extensionOptions,
        isEscapade,
        isSummerCamp,
        locale: appContext.locale,
      })}
      onSubmit={async (values: FormValues, actions: FormikHelpers) => {
        await handleSubmit(values, {
          actions,
          appContext,
          isSummerCamp,
          newsletter,
          product,
          quotation,
          trackingData,
        });
      }}
    >
      <ProductQuotationForm
        adultsOptions={adultsOptions}
        ageIndicationAdults={ageIndicationAdults}
        ageIndicationKids={ageIndicationKids}
        availableDatesIndication={availableDatesIndication}
        civilityOptions={civilityOptions}
        dateFormat={dateFormat}
        departureCityOptions={departureCityOptions}
        departureDateOptions={departureDateOptions}
        departureDateEnd={departureDateEnd}
        departureDateStart={departureDateStart}
        extensionOptions={extensionOptions}
        footnotes={footnotes}
        isEscapade={isEscapade}
        isSummerCamp={isSummerCamp}
        kidsOptions={kidsOptions}
        newsletter={newsletter}
        newsletterOptins={newsletterOptins}
      />
    </Formik>
  );
}
